import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";

@Component({
  selector: "app-training-verify-container",
  templateUrl: "./training-verify-container.component.html",
  styleUrls: ["./training-verify-container.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TrainingVerifyContainerComponent implements OnInit {
  traineeName: string = "";

  constructor(private library: FaIconLibrary) {
    library.addIcons(faUserCircle);
  }

  ngOnInit(): void {
    const traineeRaw = localStorage.getItem("trainee");
    if (traineeRaw) {
      try {
        const trainee = JSON.parse(traineeRaw);
        this.traineeName = `${trainee.first_name} ${trainee.last_name}`;
      } catch (e) {
        console.error("Error parsing trainee from localStorage", e);
      }
    }
  }
}
